import { IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { List } from "../Utils/List";
import { ObjUtils } from "../Utils/ObjUtils";

export enum DeviceCategoryType { System, User };

export class DeviceCategory implements IComparable {

	public static Snmp: DeviceCategory;
	public static NetworkDevice: DeviceCategory;
	public static CoreDevice: DeviceCategory;

	public static Server: DeviceCategory;
	public static Workstation: DeviceCategory;
	public static Printer: DeviceCategory;
	public static AciSpine: DeviceCategory;
	public static AciLeaf: DeviceCategory;
	public static Stack: DeviceCategory;
	public static Switch: DeviceCategory;
	public static Router: DeviceCategory;
	public static Firewall: DeviceCategory;
	public static WirelessController: DeviceCategory;
	public static WirelessAp: DeviceCategory;
	public static WirelessClient: DeviceCategory;
	public static WirelessRogues: DeviceCategory;
	public static IpPhoneManager: DeviceCategory;
	public static IpPhone: DeviceCategory;

	public static Windows: DeviceCategory;
	public static WindowsServer: DeviceCategory;
	public static Apple: DeviceCategory;
	public static Linux: DeviceCategory;
	public static Unix: DeviceCategory;
	public static Laptop: DeviceCategory;

    public static Virtual: DeviceCategory;
	public static VirtualHost: DeviceCategory;
    public static VirtualMachine: DeviceCategory;
	public static VirtualServer: DeviceCategory;
	public static VmWare: DeviceCategory;
	public static HyperV: DeviceCategory;
	public static VMwareVsphere: DeviceCategory;
	public static VMwareVcenter: DeviceCategory;
    public static VirtualSwitch: DeviceCategory;
    public static VirtualPortGroup: DeviceCategory;

	public static MicrosoftActiveDirectory: DeviceCategory;
	public static MicrosoftExchange: DeviceCategory;
	public static MicrosoftIIS: DeviceCategory;
	public static MicrosoftSqlServer: DeviceCategory;

	public static DhcpServer: DeviceCategory;
	public static LdapServer: DeviceCategory;
	public static SmtpServer: DeviceCategory;
	public static ImapServer: DeviceCategory;
	public static PopServer: DeviceCategory;

	public static IpCameraCCTV: DeviceCategory;

	private static Map: Dictionary<string, DeviceCategory>;

	private static __ctor = (() => {
		DeviceCategory.Snmp = new DeviceCategory("snmp", DeviceCategoryType.System);
		DeviceCategory.NetworkDevice = new DeviceCategory("net-device", DeviceCategoryType.System);
		DeviceCategory.CoreDevice = new DeviceCategory("core-device", DeviceCategoryType.System);

		DeviceCategory.Server = new DeviceCategory("server", DeviceCategoryType.System);
		DeviceCategory.Workstation = new DeviceCategory("workstation", DeviceCategoryType.System);
		DeviceCategory.Printer = new DeviceCategory("printer", DeviceCategoryType.System);
		DeviceCategory.AciSpine = new DeviceCategory("aci-spine", DeviceCategoryType.System);
		DeviceCategory.AciLeaf = new DeviceCategory("aci-leaf", DeviceCategoryType.System);
		DeviceCategory.Stack = new DeviceCategory("stack", DeviceCategoryType.System);
		DeviceCategory.Switch = new DeviceCategory("switch", DeviceCategoryType.System);
		DeviceCategory.Router = new DeviceCategory("router", DeviceCategoryType.System);
		DeviceCategory.Firewall = new DeviceCategory("firewall", DeviceCategoryType.System);
		DeviceCategory.WirelessController = new DeviceCategory("wireless-controller", DeviceCategoryType.System);
		DeviceCategory.WirelessAp = new DeviceCategory("wireless-ap", DeviceCategoryType.System);
		DeviceCategory.WirelessClient = new DeviceCategory("wireless-client", DeviceCategoryType.System);
		DeviceCategory.WirelessRogues = new DeviceCategory("wireless-rogues", DeviceCategoryType.System);
		DeviceCategory.IpPhoneManager = new DeviceCategory("ip-phone-manager", DeviceCategoryType.System);
		DeviceCategory.IpPhone = new DeviceCategory("ip-phone", DeviceCategoryType.System);

		DeviceCategory.Windows = new DeviceCategory("windows", DeviceCategoryType.System);
		DeviceCategory.WindowsServer = new DeviceCategory("windows-server", DeviceCategoryType.System);
		DeviceCategory.Apple = new DeviceCategory("apple", DeviceCategoryType.System);
		DeviceCategory.Linux = new DeviceCategory("linux", DeviceCategoryType.System);
		DeviceCategory.Unix = new DeviceCategory("unix", DeviceCategoryType.System);
		DeviceCategory.Laptop = new DeviceCategory("laptop", DeviceCategoryType.System);

        DeviceCategory.Virtual = new DeviceCategory("virtual", DeviceCategoryType.System);
        DeviceCategory.VirtualMachine = new DeviceCategory("virtual-machine", DeviceCategoryType.System);
		DeviceCategory.VirtualHost = new DeviceCategory("virtual-host", DeviceCategoryType.System);
		DeviceCategory.VirtualServer = new DeviceCategory("virtual-server", DeviceCategoryType.System);
		DeviceCategory.VmWare = new DeviceCategory("vmware", DeviceCategoryType.System);
		DeviceCategory.HyperV = new DeviceCategory("hyper-v", DeviceCategoryType.System);
		DeviceCategory.VMwareVsphere = new DeviceCategory("vsphere", DeviceCategoryType.System);
		DeviceCategory.VMwareVcenter = new DeviceCategory("vcenter", DeviceCategoryType.System);
        DeviceCategory.VirtualSwitch = new DeviceCategory("virtual-switch", DeviceCategoryType.System);
        DeviceCategory.VirtualPortGroup = new DeviceCategory("virtual-port-group", DeviceCategoryType.System);

		DeviceCategory.MicrosoftActiveDirectory = new DeviceCategory("ms-active-directory", DeviceCategoryType.System);
		DeviceCategory.MicrosoftExchange = new DeviceCategory("ms-exchange", DeviceCategoryType.System);
		DeviceCategory.MicrosoftIIS = new DeviceCategory("ms-iis", DeviceCategoryType.System);
		DeviceCategory.MicrosoftSqlServer = new DeviceCategory("ms-sqlserver", DeviceCategoryType.System);

		DeviceCategory.DhcpServer = new DeviceCategory("dhcp", DeviceCategoryType.System);
		DeviceCategory.LdapServer = new DeviceCategory("ldap", DeviceCategoryType.System);
		DeviceCategory.SmtpServer = new DeviceCategory("smtp", DeviceCategoryType.System);
		DeviceCategory.ImapServer = new DeviceCategory("imap", DeviceCategoryType.System);
		DeviceCategory.PopServer = new DeviceCategory("pop", DeviceCategoryType.System);

		DeviceCategory.IpCameraCCTV = new DeviceCategory("ip_camera_cctv", DeviceCategoryType.System);

		DeviceCategory.Map = new Dictionary<string, DeviceCategory>();

		DeviceCategory.Map.Add(DeviceCategory.Snmp.Name, DeviceCategory.Snmp);
		DeviceCategory.Map.Add(DeviceCategory.NetworkDevice.Name, DeviceCategory.NetworkDevice);
		DeviceCategory.Map.Add(DeviceCategory.CoreDevice.Name, DeviceCategory.CoreDevice);
		DeviceCategory.Map.Add(DeviceCategory.Server.Name, DeviceCategory.Server);
		DeviceCategory.Map.Add(DeviceCategory.Workstation.Name, DeviceCategory.Workstation);
		DeviceCategory.Map.Add(DeviceCategory.Printer.Name, DeviceCategory.Printer);
		DeviceCategory.Map.Add(DeviceCategory.AciSpine.Name, DeviceCategory.AciSpine);
		DeviceCategory.Map.Add(DeviceCategory.AciLeaf.Name, DeviceCategory.AciLeaf);
		DeviceCategory.Map.Add(DeviceCategory.Stack.Name, DeviceCategory.Stack);
		DeviceCategory.Map.Add(DeviceCategory.Switch.Name, DeviceCategory.Switch);
		DeviceCategory.Map.Add(DeviceCategory.Router.Name, DeviceCategory.Router);
		DeviceCategory.Map.Add(DeviceCategory.Firewall.Name, DeviceCategory.Firewall);
		DeviceCategory.Map.Add(DeviceCategory.WirelessController.Name, DeviceCategory.WirelessController);
		DeviceCategory.Map.Add(DeviceCategory.WirelessAp.Name, DeviceCategory.WirelessAp);
		DeviceCategory.Map.Add(DeviceCategory.WirelessClient.Name, DeviceCategory.WirelessClient);
		DeviceCategory.Map.Add(DeviceCategory.WirelessRogues.Name, DeviceCategory.WirelessRogues);
		DeviceCategory.Map.Add(DeviceCategory.IpPhoneManager.Name, DeviceCategory.IpPhoneManager);
		DeviceCategory.Map.Add(DeviceCategory.IpPhone.Name, DeviceCategory.IpPhone);
		DeviceCategory.Map.Add(DeviceCategory.Windows.Name, DeviceCategory.Windows);
		DeviceCategory.Map.Add(DeviceCategory.WindowsServer.Name, DeviceCategory.WindowsServer);
		DeviceCategory.Map.Add(DeviceCategory.Apple.Name, DeviceCategory.Apple);
		DeviceCategory.Map.Add(DeviceCategory.Linux.Name, DeviceCategory.Linux);
		DeviceCategory.Map.Add(DeviceCategory.Unix.Name, DeviceCategory.Unix);
		DeviceCategory.Map.Add(DeviceCategory.Laptop.Name, DeviceCategory.Laptop);
        DeviceCategory.Map.Add(DeviceCategory.Virtual.Name, DeviceCategory.Virtual);
		DeviceCategory.Map.Add(DeviceCategory.VirtualHost.Name, DeviceCategory.VirtualHost);
        DeviceCategory.Map.Add(DeviceCategory.VirtualMachine.Name, DeviceCategory.VirtualMachine);
		DeviceCategory.Map.Add(DeviceCategory.VirtualServer.Name, DeviceCategory.VirtualServer);
		DeviceCategory.Map.Add(DeviceCategory.VmWare.Name, DeviceCategory.VmWare);
		DeviceCategory.Map.Add(DeviceCategory.HyperV.Name, DeviceCategory.HyperV);
		DeviceCategory.Map.Add(DeviceCategory.VMwareVsphere.Name, DeviceCategory.VMwareVsphere);
		DeviceCategory.Map.Add(DeviceCategory.VMwareVcenter.Name, DeviceCategory.VMwareVcenter);
		DeviceCategory.Map.Add(DeviceCategory.VirtualSwitch.Name, DeviceCategory.VirtualSwitch);
        DeviceCategory.Map.Add(DeviceCategory.VirtualPortGroup.Name, DeviceCategory.VirtualPortGroup);
		DeviceCategory.Map.Add(DeviceCategory.MicrosoftActiveDirectory.Name, DeviceCategory.MicrosoftActiveDirectory);
		DeviceCategory.Map.Add(DeviceCategory.MicrosoftExchange.Name, DeviceCategory.MicrosoftExchange);
		DeviceCategory.Map.Add(DeviceCategory.MicrosoftIIS.Name, DeviceCategory.MicrosoftIIS);
		DeviceCategory.Map.Add(DeviceCategory.MicrosoftSqlServer.Name, DeviceCategory.MicrosoftSqlServer);
		DeviceCategory.Map.Add(DeviceCategory.DhcpServer.Name, DeviceCategory.DhcpServer);
		DeviceCategory.Map.Add(DeviceCategory.LdapServer.Name, DeviceCategory.LdapServer);
		DeviceCategory.Map.Add(DeviceCategory.SmtpServer.Name, DeviceCategory.SmtpServer);
		DeviceCategory.Map.Add(DeviceCategory.ImapServer.Name, DeviceCategory.ImapServer);
		DeviceCategory.Map.Add(DeviceCategory.PopServer.Name, DeviceCategory.PopServer);
		DeviceCategory.Map.Add(DeviceCategory.IpCameraCCTV.Name, DeviceCategory.IpCameraCCTV);
	})();

	public static Get(name: string): DeviceCategory {
		var result = null;

		result = DeviceCategory.Map.Item(name);
		if (!result) {
			result = new DeviceCategory(name, DeviceCategoryType.User);
            DeviceCategory.Map.Add(name, result);
		}

		return result;
	}

	public static GetAll(): List<DeviceCategory> {
		return DeviceCategory.Map.Values();
	}

	private _name: string;
	public get Name(): string {
		return this._name;
	}

	private _type: DeviceCategoryType;
	public get Type(): DeviceCategoryType {
		return this._type;
	}

	constructor(name: string, type: DeviceCategoryType) {
		this._name = name;
		this._type = type;
	}

	public toString(): string {
		return this._name;
	}

	public Equals(obj: any): boolean {
		if (obj == this)
			return true;
		if (obj == null)
			return false;
		if (!(obj instanceof DeviceCategory))
			return false;

		var other = <DeviceCategory>obj;

		return (this.Name == other.Name);
	}

	public GetHashCode(): number {
		return ObjUtils.GetHashCode(this.Name);
	}

	public CompareTo(other: DeviceCategory): number {
		if (!other)
			return 1;

		return ObjUtils.CompareTo(this.Name, other.Name);
	}
}
